import ApiService from './ApiService'

// ----- Types for Payment Verification -----

export type SessionStatusResponse = {
  status: 'NOT_FOUND' | 'PENDING' | 'SUCCESS' | 'FAILED' | 'EXPIRED'
  message: string
}

// ----- Payment Verification Endpoints -----

/**
 * Get the status of a payment session.
 * Called to check the status of a payment session.
 * Endpoint: GET /api/payments/session/xxxx
 * @param sessionId - The session ID to check the status of
 */
export async function apiSessionStatus<T = SessionStatusResponse>(sessionId: string) {
  return ApiService.fetchData<T>({
    url: `/api/stripe/status/${sessionId}`,
    method: 'get'
  })
}
